import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=3e0f702e&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=3e0f702e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f702e",
  null
  
)

/* custom blocks */
import block0 from "./BaseContainer.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports